import { useLocalObservable } from 'mobx-react-lite';
import StoreAction from '@store/StoreAction';
import { runInAction } from 'mobx';
import { getQryLendDetail } from '@api';

const initialState = {
    startDate: new Date(),
    endDate: new Date(),
    lendDetails: [],
};

const api = {
    qryLendDetail: getQryLendDetail,
};
const LoanDetailStore = () =>
    useLocalObservable(() => ({
        /* observables */
        ...initialState,
        ...StoreAction(initialState),
        ...api,
        async getQryLendDetail(defaultValue, startDate, endDate) {
            const postData = {
                queryType: defaultValue,
                startDate: startDate,
                endDate: endDate,
            };
            const res = await this.qryLendDetail(postData);
            const lendDetails = res.data.items;
            this.assignData({ lendDetails });
        },
    })); // 3

export default LoanDetailStore; // 2
